import normalizePositionByRangeLength from "./normalizePositionByRangeLength";
import { assign } from "lodash-es";
export default function expandOrContractCircularRangeToPosition(range, position, maxLength) {
  const newRange = assign({}, range);
  let endMoved = true;
  if (range.end >= position) {
    if (position + maxLength - range.start > range.end - position) {
      newRange.end = normalizePositionByRangeLength(
        position - 1,
        maxLength,
        false
      );
    } else {
      newRange.start = position;
      endMoved = false;
    }
  } else {
    if (range.start < position) {
      if (range.end + maxLength - position > position - range.start) {
        newRange.start = position;
        endMoved = false;
      } else {
        newRange.end = position - 1;
      }
    } else {
      if (range.start - position > position - range.end) {
        newRange.end = position - 1;
      } else {
        endMoved = false;
        newRange.start = position;
      }
    }
  }
  return {
    newRange,
    endMoved
  };
}
